module.exports = __webpack_public_path__ + "static/media/LegoCaveSpiderQueenLabA0121_design_clean_v002.488f6fed.png";